import React from 'react';
import './App.css';
import AppRouter from './router';
import { Provider } from 'react-redux'
import store from './store'
import 'antd-mobile-v2/dist/antd-mobile.css';
import VConsole from 'vconsole';

function App() {
  if(process.env.REACT_APP_TARGET_ENV === 'dev'){
    // eslint-disable-next-line
    const vConsole = new VConsole();
  }
  return (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
}

export default App;
